function ErrorMessage({ message }) {
  return <p className="error">Error: {message}</p>;
}

export default ErrorMessage;
